export enum ProductCombinationAttributeSlug {
  Color = 'cor',
  Voltage = 'voltagem',
}
